export default __webpack_public_path__ + "locales/tr/Translations.json?hash=00c131c5380bdad6c6af135b760534ce";